import IssuesList from "./IssuesList";
import IssuesEdit from "./IssuesEdit";
import {IssuesShow} from "./IssuesShow";

export default {
    list: IssuesList,
    show: IssuesShow,
};
